export enum AutoAssignPackagesToDriversMethod {
    BY_DRIVER_DISTANCE_AND_SHIPPING_LINE = 'BY_DRIVER_DISTANCE_AND_SHIPPING_LINE',
    BY_DRIVER_DISTANCE = 'BY_DRIVER_DISTANCE',
    BY_DRIVER_PRIORITY = 'BY_DRIVER_PRIORITY',
    SINGLE_SHIPPING_LINE_DRIVER  = 'SINGLE_SHIPPING_LINE_DRIVER'
}
